import React from 'react';

const SlidersHorizontalIcon = (props) => {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" width={props.width ? props.width : '24'}
             height={props.height ? props.height : '24'} viewBox="0 0 24 24" fill="none"
             stroke={props.stroke ? props.stroke : 'currentColor'} strokeWidth="2" strokeLinecap="round"
             strokeLinejoin="round"
        >
            <path d="M10 5H3"/>
            <path d="M12 19H3"/>
            <path d="M14 3v4"/>
            <path d="M16 17v4"/>
            <path d="M21 12h-9"/>
            <path d="M21 19h-5"/>
            <path d="M21 5h-7"/>
            <path d="M8 10v4"/>
            <path d="M8 12H3"/>
        </svg>
    );
};

export default SlidersHorizontalIcon;


// WEBPACK FOOTER //
// ./src/assets/icons/SlidersHorizontalIcon.jsx